<template>
  <div class="children-day-draw-component">
    <ym-popup class="children-day-draw-popup"
              v-model="visible"
              :close-on-click-overlay="!showDrawLoading"
    >
      <ym-img v-if="showDrawLoading"
              class="children-day-draw-gif"
              :src="require('@/pages/2021/ChildrenDay/assets/img/draw_open.gif')"
      />
      <div v-if="!showDrawLoading && result"
           class="children-day-draw-container"
      >
        <div class="children-day-draw-container-title"
             :class="{ 'disable': !result.prize }"
        >
          {{ result.prize ? '恭喜你' : '很遗憾' }}
        </div>
        <div v-if="result.prize"
             class="children-day-draw-container-prize"
        >
          <div class="content">
            这个盲盒里面有
          </div>
          <ym-img class="image"
                  :src="result.prize.cover"
          />
          <div class="title">
            {{ result.prize.title }}
          </div>
          <div class="desc">
            {{ result.prize.desc }}
          </div>
        </div>
        <div v-else
             class="children-day-draw-container-empty"
        >
          <div class="content">
            这个盲盒里面什么也没有
          </div>
          <ym-img class="image"
                  :src="require('@/pages/2021/ChildrenDay/assets/img/draw_empty.png')"
          />
        </div>
        <div class="children-day-draw-container-btn"
             @click="handleClose"
        >
          {{ drawText }}
        </div>
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';
  import { getChildrenDayPrizeDrawResult } from '@/services/children-day-2021';

  export default {
    name: 'DrawResultPopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
        showDrawLoading: false,
        result: null,
      };
    },
    computed: {
      drawText() {
        if (this.result.drawCount === 0) {
          return this.result.haveShare ? '分享好友，可再开一个' : '明天再开';
        }
        return '再开一个';
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      async handleDraw() {
        if (this.showDrawLoading) return;
        this.showDrawLoading = true;
        try {
          const data = await getChildrenDayPrizeDrawResult();
          setTimeout(() => {
            this.showDrawLoading = false;
            this.result = data;
            this.$emit('success', data);
          }, 1000);
        } catch (e) {
          setTimeout(() => {
            this.showDrawLoading = false;
            this.result = null;
            this.visible = false;
          }, 1000);
        }
      },
      async handleClose() {
        this.$emit('close', this.drawText === '分享好友，可再开一个');
        this.showDrawLoading = false;
        this.result = null;
        this.visible = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .children-day-draw {
    &-popup {
      background: none;
    }
    &-gif {
      width: 477px;
      height: 535px;
    }
    &-container {
      width: 600px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: @color-white;
      border-radius: 20px;
      &-title {
        width: 100%;
        height: 120px;
        color: @color-white;
        font-size: 45px;
        font-weight: @font-weight-bold;
        text-align: center;
        line-height: 120px;
        background: #f75748;
        border-radius: 20px 20px 0 0;
        &.disable {
          background: #c9c9c9;
        }
      }
      &-prize {
        display: flex;
        flex-direction: column;
        align-items: center;
        .content {
          color: #f75748;
          font-size: 34px;
          font-weight: @font-weight-bold;
          line-height: 34px;
          padding: 40px 0 22px;
          box-sizing: border-box;
        }
        .image {
          width: 294px;
          height: 206px;
        }
        .title {
          color: #f75748;
          font-size: 34px;
          line-height: 34px;
          margin: 26px 0 20px;
        }
        .desc {
          color: @color-text-light;
          font-size: 26px;
          line-height: 38px;
          text-align: center;
          margin-bottom: 30px;
          padding: 0 50px;
        }
      }
      &-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        .content {
          font-size: 34px;
          color: @color-text-light;
          height: 128px;
          line-height: 128px;
          text-align: center;
        }
        .image {
          width: 207px;
          height: 232px;
          margin-bottom: 57px;
        }
      }
      &-btn {
        width: 453px;
        height: 84px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: 34px;
        font-weight: @font-weight-bold;
        border-radius: 42px;
        background: #f75748;
        margin-bottom: 53px;
      }
    }
  }
</style>
